// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"132":"abd46e4f","299":"a2238687","382":"6017b058","396":"d8b4001d","453":"b03e3c98","542":"2266daa6","600":"6f9c27fa","734":"e035d80a","864":"dc04b095"}[chunkId] + ".chunk.js";
};